<template>
  <v-row no-gutters class="icon-tile">
    <v-col cols="12" @mouseover="isHover = true" @mouseout="isHover = false">
      <v-icon
        v-show="isHover"
        @mouseover="isHover = true"
        @mouseout="isHover = false"
        size="14px"
        color="#bababa"
        class="icon-delete-button"
        @click="confirmDeleteIcon"
      >
        mdi-close
      </v-icon>
      <v-row no-gutters align="center" class="icon-tile-image-row">
        <v-col cols="12" class="d-flex align-center justify-center">
          <img width="20px" height="20px" :src="getStyleExternalGraphicIcon(icon.name)" style="scale: 250%" />
        </v-col>
      </v-row>
      <v-tooltip bottom max-width="300">
        <template #activator="{ on }">
          <v-row v-on="on" no-gutters align="center" justify="center" class="icon-tile-name-row">
            <v-col cols="10" class="text-truncate">{{ icon.name }}</v-col>
          </v-row>
        </template>
        {{ icon.name }}
      </v-tooltip>
    </v-col>
    <main-dialog
      v-if="isConfirmDeleteIconLoaded"
      :is-visible.sync="isConfirmDeleteIconVisible"
      :title="$i18n.t('dialog.deleteIcon')"
      :body="$i18n.t('dialog.confirmIconDelete')"
      :loading="isConfirmDeleteIconLoading"
      agree-text="dialog.agreeDelete"
      @agree="deleteIconHandler"
    ></main-dialog>
  </v-row>
</template>
<script>
import { call } from 'vuex-pathify';
import stylePreviewUtilities from '@/mixins/stylePreviewUtilities';
export default {
  name: 'IconTile',
  mixins: [stylePreviewUtilities],
  components: {
    MainDialog: () => import('@/components/MainDialog'),
  },
  props: {
    icon: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    isConfirmDeleteIconLoading: false,
    isConfirmDeleteIconVisible: false,
    isConfirmDeleteIconLoaded: false,
    isHover: false,
  }),
  methods: {
    deleteIcon: call('layers/deleteIcon'),
    async deleteIconHandler() {
      this.isConfirmDeleteIconLoading = true;
      await this.deleteIcon(this.icon.name);
      this.$root.$emit('iconDeleted', this.icon.name);
      this.isConfirmDeleteIconLoading = false;
      this.isConfirmDeleteIconVisible = false;
      this.isConfirmDeleteIconLoaded = false;
    },
    confirmDeleteIcon() {
      this.isConfirmDeleteIconVisible = true;
      this.isConfirmDeleteIconLoaded = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.icon-tile {
  border: 1px solid rgba(0, 0, 0, 0.18);
  border-radius: 4px;
  height: 75px;
  position: relative;
}
.icon-tile-image-row {
  height: 65%;
}
.icon-tile-name-row {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 10px;
  line-height: 16px;
  height: 25%;
}
.icon-delete-button {
  position: absolute;
  top: 0.2rem;
  right: 0.2rem;
}
</style>
